<template>
  <div>
    <div class="banner withoutImg">
      <div class="container">
        <div class="caption">
          <p><h1>注册</h1></p>
          <br>
          <p>感谢关注JMIB，填写并提交表单即可注册</p>
        </div>
      </div>
    </div>
    <!-- Main content area start here -->
    <section class="innerPage myaccount">
      <div class="container">
        <div class="breadcrumbWrap">
          <div class="breadcrumb">
            <!-- Breadcrumb NavXT 6.2.0 -->
            <span property="itemListElement" typeof="ListItem">
              <a
                property="item"
                typeof="WebPage"
                title="Go to Jasper Morris Inside Burgundy."
                href="#/"
                class="home"
              >
                <span property="name">首页</span>
              </a>
              <meta property="position" content="1">
            </span> /
            <span property="itemListElement" typeof="ListItem">
              <span property="name">注册</span>
              <meta property="position" content="2">
            </span>
          </div>
        </div>

        <registerBax />
      </div>
    </section>
  </div>
</template>
<script>
import registerBax from '../template/registertamp'
export default {
  components:{
    registerBax
  },
  methods: {
    changeActive($event) {
      $event.currentTarget.style = "border-bottom: 4px solid #990033;";
    },
    removeActive($event) {
      $event.currentTarget.style = "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Register.vue